export const NOTICE_KINDS = ['base', 'error', 'info', 'success', 'warning'];
export const NOTICE_ROLES = ['alert', 'alertdialog', 'status'];

export default {
  NOTICE_KINDS,
  NOTICE_ROLES,
};
